import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
} from 'reactstrap';

import AdminPanelOnlineUserListItem from './OnlineUserListItem';

const AdminPanelOnlineUserList = ({
  users,
}) => (
  <Table responsive bordered>
    <tbody>
      {users.map(user => (
        <AdminPanelOnlineUserListItem
          key={user.uuid}
          user={user}
        />
      ))}
    </tbody>
  </Table>
);

AdminPanelOnlineUserList.propTypes = {
  users: PropTypes.array.isRequired,
};

export default AdminPanelOnlineUserList;
